<section class="d-flex h-full-header ">
  <div class="payment-list-cntr border-left flex-fill">
    <form class="d-flex flex-wrap my-2">
      <label>
        <span>جستجو</span>
        <input class="p-1 fs-sm" type="search" placeholder="جستجو" name="keyword" [(ngModel)]="criteria.q">
      </label>
      <label class="m-1">
        <span>از تاریخ</span>
        <app-calendar name="time-from" [(ngModel)]="criteria.time_from"></app-calendar>
      </label>
      <label class="m-1">
        <span>تا تاریخ</span>
        <app-calendar name="time-to" [(ngModel)]="criteria.time_to"></app-calendar>
      </label>
      <label class="m-1">
        <span>نوع</span>
        <select name="type" [(ngModel)]="criteria.type">
          <option [value]="0">همه</option>
          <option [value]="1">افزودن اعتبار</option>
          <option [value]="2">اعتبار آگهی</option>
          <option [value]="6">افزایش اعتبار آگهی</option>
          <option [value]="3">کارجوی پیشتاز</option>
          <option [value]="4">خرید رزومه</option>
          <option [value]="5">خرید فایل</option>
        </select>
      </label>
      <label class="m-1">
        <span>وضعیت</span>
        <select name="status" [(ngModel)]="criteria.status">
          <option [value]="-1">همه</option>
          <option [value]="0">معلق</option>
          <option [value]="1">ناموفق</option>
          <option [value]="2">ناقص</option>
          <option [value]="3">موفق</option>
        </select>
      </label>
      <label class="m-1">
        <span>درگاه</span>
        <select name="provider" [(ngModel)]="criteria.provider">
          <option [value]="-1">همه</option>
          <option [value]="4">کارت به کارت</option>
          <option [value]="5">به پرداخت</option>
          <option [value]="6">سپ</option>
          <option [value]="1">pay.ir</option>
          <option [value]="2">Zarinpal</option>
          <option [value]="3">Payping</option>
        </select>
      </label>
      <div class="m-1">
        <button class="btn btn-blue btn-sm" (click)="navigate()">جستجو</button>
      </div>
    </form>
    <div class="col-12 text-center">
      <app-pagination [total]="total" [limit]="criteria.limit"></app-pagination>
    </div>
    <div class="p-1 table-responsive">
      <table class="w-100 table table-striped table-sm fs-sm">
        <thead>
          <tr>
            <td>عنوان</td>
            <td>مبلغ</td>
            <td>وضعیت</td>
            <td>تاریخ</td>
            <td>درگاه</td>
            <td>کد پیگیری</td>
            <td>نام</td>
            <td>شماره موبایل</td>
            <td>توضیحات</td>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let payment of payments">
            <td>{{payment.Description}}</td>
            <td>
              <div class="d-flex">
                {{payment.Amount|number}}
                <!-- <i class="fa fa-edit fs-lg pointer"
                *ngIf="!payment._amount && payment.Status == 0 && payment.Provider == 4"
                (click)="payment._amount=payment.Amount"></i>
              <div *ngIf="payment._amount">
                <input [(ngModel)]="payment._amount" style="width:70px" />
                <i class="fa fa-check f-green fs-lg pointer" (confirm)="changeAmount(payment.Id, payment._amount)"></i>
              </div> -->
              </div>
            </td>
            <td>
              <div [ngSwitch]="payment.Status">
                <div class="fs-sm badge white-bg" *ngSwitchCase="0">معلق</div>
                <div class="fs-sm badge red-bg f-white" *ngSwitchCase="1">ناموفق</div>
                <div class="fs-sm badge white-bg" *ngSwitchCase="2">ناقص</div>
                <div class="fs-sm badge f-white" *ngSwitchCase="3" [class.green-bg]="payment.Amount>=0"
                  [class.yellow-bg]="payment.Amount<0">موفق</div>
                <div class="fs-sm badge light-gray-bg f-white" *ngSwitchCase="-1">لینک</div>
                <div *ngSwitchDefault>نامعلوم</div>
              </div>
            </td>
            <td>{{payment.CreateTime|pdate}}</td>
            <td>
              <div [ngSwitch]="payment.Provider">
                <div *ngSwitchCase="1">پرداخت پی</div>
                <div *ngSwitchCase="2">زرین پال</div>
                <div *ngSwitchCase="3">پی پینگ</div>
                <div *ngSwitchCase="5">به پرداخت</div>
                <div *ngSwitchCase="6">سپ</div>
                <div *ngSwitchCase="4" class="">کارت به کارت</div>
                <div *ngSwitchDefault></div>
              </div>
              <div class="d-flex justify-content-between" *ngIf="(payment.Provider==4 && payment.Status==0) || payment.Status==2">
                <i class="fa fa-check f-green fs-lg pointer m-1" (confirm)="verifyLink(payment, true)"></i>
                <i class="fa fa-times f-red fs-lg pointer m-1" *ngIf="payment.Status==0"
                  (confirm)="verifyLink(payment, false)"></i>
              </div>
              <div *ngIf="payment._verifyLink">
                <a class="btn btn-link btn-sm f-blue" [href]="payment._verifyLink" target="_blank">تکمیل</a>
              </div>
            <td>{{payment.Token}}</td>
            <td>{{payment.Item?.name}}</td>
            <td>
              <a target="_blank" class="btn btn-link f-blue" [routerLink]="['/admin/user']"
                [queryParams]="{q:payment.Mobile}">{{payment.Mobile}}</a>
            </td>
            <td>
              <div class="d-flex">
                <div [ngSwitch]="payment.ItemType">
                  <div *ngSwitchCase="0">-</div>
                  <div *ngSwitchCase="1">افزایش بودجه</div>
                  <div *ngSwitchCase="2">بودجه آگهی <a [routerLink]="['/admin/ads', {job: payment.Item.id}]"
                      target="_blank" class="btn btn-link fs-sm" *ngIf="payment.Item">
                      {{payment.Item.title}} (ویرایش)
                    </a>
                  </div>
                  <div *ngSwitchCase="3">پیشتاز کردن کارجو</div>
                  <div *ngSwitchCase="4">خرید رزومه</div>
                  <div *ngSwitchCase="5">خرید فایل</div>
                  <div *ngSwitchCase="6">افزایش بودجه آگهی <a [routerLink]="['/admin/ads', {job: payment.Item.id}]"
                      target="_blank" class="btn btn-link fs-sm" *ngIf="payment.Item">
                      {{payment.Item.title}} (ویرایش)
                    </a></div>
                  <div *ngSwitchCase="7">کارپاشا</div>
                  <div *ngSwitchCase="8">کاریار</div>
                  <div *ngSwitchCase="9">ثبت نام کاریابی</div>
                  <div *ngSwitchCase="10">تعرفه کاریابی</div>
                  <div *ngSwitchDefault>-</div>
                </div>
                <div *ngIf="payment.OriginalAmount && payment.OriginalAmount != payment.Amount">
                  مبلغ اصلی: {{payment.OriginalAmount}}
                </div>
                <button class="btb btn-link fs-sm" (click)="payment._showData=!payment._showData">جزئیات</button>

              </div>
              <pre class="text-left fs-sm white-bg p-2 overflow-auto" dir="ltr" style="max-width: 600px;"
                *ngIf="payment._showData">
              {{payment | json}}
            </pre>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="text-center">
      <app-pagination [total]="total" [limit]="criteria.limit"></app-pagination>
    </div>
  </div>
  <div class="h-100">
    <table *ngIf="records?.length" class="table table-striped table-sm fs-sm">
      <thead>
        <tr>
          <td>ذینفع</td>
          <td>مبلغ</td>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let record of records">
          <td>{{record.BeneficiaryText}}</td>
          <td>{{record.Amount|number}}</td>
        </tr>
      </tbody>
    </table>

    <comm-communication-list [reverse]="true" [criteria]="{EventLog:{ Actions:['start-payment']}}">
    </comm-communication-list>
  </div>
</section>